// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"939":"8325015c585666e3","6583":"7e0d38057b1cf1e5","8769":"87c8e80d45f88c37"}[chunkId] + ".js";
};